import { uscgNav } from "./portalNavAids";
import { njdotChan} from "./portalNjdotChan";

export const navLayers ={
  id: 'navigation',
  title: "Navigation Layers",
  type: 'group',
  items: [
    uscgNav,
    njdotChan,
  ]
};

